import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { useIntl } from 'react-intl'

const NotificationEmpty = props => {
    useStyles(classes)
    const Intl = useIntl()

    return(
        <div className={classes.NotificationEmpty}>
            <Iconfont className={classes.EmptyIcon}>&#xe7c6;</Iconfont>
            <span className={classes.EmptyTxt}>{Intl.formatMessage({id: 'empty_here'}) +' :-('}</span>
        </div>
    )
}

export default NotificationEmpty